import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Users, Store } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import DashboardLayout, { NavCard } from '../components/DashboardLayout';
import { usePerms } from '../permissions/PermissionsContext';

export default function CloudGMFinance() {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const { visiblePages } = usePerms();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const items = [
    {
      id: 'customer-platform',
      titleAr: 'منصة العملاء',
      titleEn: 'Customer Platform',
      descAr: 'الإدارة المالية لمنصة العملاء',
      descEn: 'Financial management for customer platform',
      icon: Users,
      route: '/dashboard/finance/cloudgm/customers',
      color: '#3B82F6',
      screenCode: 'CGM-FIN-CUST',
    },
    {
      id: 'merchant-platform',
      titleAr: 'منصة التجار',
      titleEn: 'Merchant Platform',
      descAr: 'الإدارة المالية لمنصة التجار',
      descEn: 'Financial management for merchant platform',
      icon: Store,
      route: '/dashboard/finance/cloudgm/merchants',
      color: '#10b981',
      screenCode: 'CGM-FIN-MERCH',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  return (
    <DashboardLayout
      title="CLOUDGM FZ LLC (المالية)"
      titleEn="CLOUDGM FZ LLC (Finance)"
      subtitle="إدارة الشؤون المالية لمنصة كلاود جي إم"
      subtitleEn="Financial management for CloudGM platform"
      screenCode="FIN-CGM"
      backPath="/dashboard/finance"
      breadcrumb={[
        { labelAr: 'المالية', labelEn: 'Finance', path: '/dashboard/finance' },
        { labelAr: 'CLOUDGM FZ LLC (المالية)', labelEn: 'CLOUDGM FZ LLC (Finance)', path: null }
      ]}
    >
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          {visiblePages(items, 'route').map((item) => (
            <NavCard
              key={item.id}
              icon={item.icon}
              title={item.titleAr}
              titleEn={item.titleEn}
              description={item.descAr}
              descriptionEn={item.descEn}
              onClick={() => navigate(item.route)}
              color={item.color}
              screenCode={item.screenCode}
            />
          ))}
        </motion.div>
      </section>
    </DashboardLayout>
  );
}
